var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.isshow,"custom-style":_vm.custom,"z-index":"9999"}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"box"},[_c('van-loading',{attrs:{"size":"24px","color":"#1989fa","vertical":""}},[_vm._v(_vm._s(_vm.text)+"...")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }